import React from "react";

import ATextfield, { TextFieldProps } from "@atlaskit/textfield";

export const TextField: React.FC<TextFieldProps & any> = React.forwardRef((props, ref) => (
  <ATextfield {...(props as any)} ref={ref} />
));

export type { TextFieldProps };
